import { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
  LayoutDashboard,
  Users,
  Kanban,
  FileText,
  ArrowLeft,
  Shield,
  BarChart3,
  GitMerge,
  Settings,
  Plug,
} from 'lucide-react';

const navItems = [
  {
    label: 'Dashboard',
    href: '/admin/dashboard',
    icon: LayoutDashboard,
  },
  {
    label: 'Analytics',
    href: '/admin/analytics',
    icon: BarChart3,
  },
  {
    label: 'Users',
    href: '/admin/users',
    icon: Users,
  },
  {
    label: 'Boards',
    href: '/admin/boards',
    icon: Kanban,
  },
  {
    label: 'Posts',
    href: '/admin/posts',
    icon: FileText,
  },
  {
    label: 'Duplicates',
    href: '/admin/duplicates',
    icon: GitMerge,
  },
  {
    label: 'Audit Logs',
    href: '/admin/audit-logs',
    icon: Shield,
  },
  {
    label: 'Settings',
    href: '/admin/settings',
    icon: Settings,
  },
  {
    label: 'Integrations',
    href: '/admin/integrations',
    icon: Plug,
  },
];

export const AdminSidebar = memo(function AdminSidebar() {
  const { pathname } = useLocation();

  return (
    <aside className="w-[200px] border-r bg-card min-h-screen">
      <div className="p-6">
        <h2 className="text-lg font-semibold">Admin Panel</h2>
        <p className="text-sm text-muted-foreground">Manage your platform</p>
      </div>

      <nav className="px-3 space-y-1">
        {navItems.map((item) => {
          const isActive = pathname === item.href;
          const Icon = item.icon;

          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                'px-3 py-2 text-sm font-medium rounded-md flex items-center gap-2 transition-colors',
                isActive
                  ? 'bg-muted text-foreground'
                  : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              )}
            >
              <Icon className="h-4 w-4" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="px-3 mt-8">
        <Link
          to="/"
          className="px-3 py-2 text-sm font-medium rounded-md flex items-center gap-2 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to site
        </Link>
      </div>
    </aside>
  );
});
